<template>
  <div class="dbc-cancel-contract-info-box" v-if="state === 'infilling'">
    <div class="dbc-cancel-contract-info-box-inner">
      <DbcSvg name="dbc-icon-info" />
      <UtilityText :text="$t('dbc-cancel-contract-log-in-request-text')" />
    </div>
    <UtilityButton
      class="dbc-cancel-contract-info-box-button"
      :button="{
        type: 'primary',
        link: selfServiceDeepLink!,
        text: $t('dbc-cancel-contract-log-in-request-button'),
      }"
    />
  </div>

  <div ref="infoBoxErrorMessageTemplateRef" tabindex="-1">
    <div class="dbc-cancel-contract-info-box" v-if="state === 'error'">
      <div class="dbc-cancel-contract-info-box-inner">
        <DbcSvg name="dbc-icon-error" />
        <UtilityText :text="$t('dbc-cancel-contract-box-error-message')" />
      </div>
      <UtilityButton
        class="dbc-cancel-contract-info-box-button"
        :button="{
          type: 'primary',
          link: getPagePath['cancelContract']![locale]!,
          text: $t('dbc-cancel-contract-box-error-button'),
        }"
        @click="onClickTryAgain"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  state: CancelContractStates
}>()

const emit = defineEmits(['onClickTryAgain'])

const { locale } = useI18n()

function onClickTryAgain() {
  emit('onClickTryAgain')
}

const selfServiceDeepLink = getPagePath['contract-cancel']![locale.value]

const infoBoxErrorMessageTemplateRef = ref<HTMLElement | null>(null)

onMounted(() => {
  if (props.state === 'error') {
    infoBoxErrorMessageTemplateRef.value?.scrollIntoView()
    infoBoxErrorMessageTemplateRef.value?.focus()
  }
})
</script>
